import React from 'react';
import Icon from '../../../components/AppIcon';

const TaxSummaryCards = () => {
  const taxSummaries = [
    {
      type: 'Sales Tax',
      amount: '$12,450',
      period: 'Q1 2026',
      dueDate: 'Feb 15, 2026',
      status: 'pending',
      icon: 'ShoppingCart',
      color: 'blue'
    },
    {
      type: 'Payroll Tax',
      amount: '$8,320',
      period: 'January 2026',
      dueDate: 'Feb 10, 2026',
      status: 'pending',
      icon: 'Users',
      color: 'green'
    },
    {
      type: 'Income Tax',
      amount: '$24,680',
      period: 'Q4 2025',
      dueDate: 'Jan 31, 2026',
      status: 'overdue',
      icon: 'DollarSign',
      color: 'red'
    },
    {
      type: 'Property Tax',
      amount: '$5,200',
      period: '2026',
      dueDate: 'Mar 1, 2026',
      status: 'upcoming',
      icon: 'Home',
      color: 'purple'
    }
  ];

  const getStatusColor = (status) => {
    const colors = {
      pending: 'bg-yellow-100 text-yellow-800',
      overdue: 'bg-red-100 text-red-800',
      upcoming: 'bg-blue-100 text-blue-800',
      paid: 'bg-green-100 text-green-800'
    };
    return colors?.[status] || colors?.pending;
  };

  const getIconColor = (color) => {
    const colors = {
      blue: 'text-blue-600 bg-blue-100',
      green: 'text-green-600 bg-green-100',
      red: 'text-red-600 bg-red-100',
      purple: 'text-purple-600 bg-purple-100'
    };
    return colors?.[color] || colors?.blue;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {taxSummaries?.map((tax, index) => (
        <div
          key={index}
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow"
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getIconColor(tax?.color)}`}>
              <Icon name={tax?.icon} size={24} />
            </div>
            <span className={`px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(tax?.status)}`}>
              {tax?.status}
            </span>
          </div>

          <h3 className="text-lg font-semibold text-gray-900 mb-1">{tax?.type}</h3>
          <p className="text-2xl font-bold text-gray-900 mb-2">{tax?.amount}</p>
          <p className="text-sm text-gray-600 mb-1">{tax?.period}</p>
          <p className="text-sm text-gray-500">Due: {tax?.dueDate}</p>
        </div>
      ))}
    </div>
  );
};

export default TaxSummaryCards;